import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  employeeDetails = {
    email: '',
    employeeCode: '',
    setPassword: false
  }
  constructor() { }

  setEmployeeDetails(incomingDetails: any) {
    this.employeeDetails.email = incomingDetails.email
    this.employeeDetails.employeeCode = incomingDetails.employeeCode
    this.employeeDetails.setPassword = true
  }

  getEmployeeDetails() {
    return this.employeeDetails
  }

  setEmailInLocalStorage(email: string) {
    localStorage.setItem("email", email)
  }

  getEmailFromLocalStorage() {
    return localStorage.getItem("email")
  }
  
}
